import Vue, {CreateElement, RenderContext, VNode} from "vue";

/**
 * icon-btn のアイコン種別
 */
export type TypeType =
    'edit' | 'edit-content' | 'view' | 'delete' | 'disuse' | 'add';

/**
 * icon-btn のアイコン種別毎のの順番を取得します
 *
 * @param type icon-btn のアイコン種別毎のの順番
 * @param defaultValue デフォルトの順番
 */
function typeOrder(type?: TypeType, defaultValue?: number | string): number {
  switch(type) {
    case 'delete':
      return 10;
    case 'disuse':
      return 11;
    case 'edit-content':
      return 20;
    case 'edit':
      return 30;
    case 'view':
      return 40;
    default:
      switch(typeof defaultValue) {
        case 'undefined':
          return 50;
        case 'number':
          return defaultValue;
        default:
          return parseInt(defaultValue, 10);
      }
  }
}

/**
 * icon-btn のプロパティー
 */
interface IconBtnPropsType {
  /** 種別 */
  type: TypeType | undefined;

  /** 順番 */
  order: number | string | undefined;
}

/**
 * 内包するアイコンを種別毎にソートします
 */
export default Vue.extend({
  functional: true,
  name: 'IconBtns',
  render(createElement: CreateElement, ctx: RenderContext): VNode {
    let elements: VNode[] = ctx.slots().default;
    if(!elements?.length) {
      elements = [];
    }

    // ソート
    elements = elements
        .map((vnode, index) => ({vnode, index}))
        .sort((a, b) => {
          const aidx = a.index, bidx = b.index;
          const aco = a.vnode.componentOptions, bco = b.vnode.componentOptions;
          if(aco?.tag === 'icon-btn' && bco?.tag === 'icon-btn') {
            const apd = aco?.propsData as IconBtnPropsType, bpd = bco?.propsData as IconBtnPropsType;
            const to = typeOrder(apd?.type, apd?.order) - typeOrder(bpd?.type, bpd?.order);
            return to === 0 ? aidx - bidx : to;
          } else if(aco?.tag === 'icon-btn' && bco?.tag !== 'icon-btn') {
            return -1;
          } else if(aco?.tag !== 'icon-btn' && bco?.tag === 'icon-btn') {
            return 1;
          } else {
            return aidx - bidx;
          }
        })
        .map(vn => vn.vnode);

    return createElement('div', {
      class: 'icon-btns'
    }, elements);
  }
});
